import { Gender } from '~/pages/CreateNewCharacter';
import GenerateLoading from '~/components/Loading/GenerateLoading';
import { Header, SubCloseButton } from '~/components/common/Header';
import SetProfileView from '~/components/common/SetProfileView/SetProfileView';
import useDetailInput from '~/hooks/CreateNewCharacter/useDetailInput';

export interface DetailInputProps {
  gender: Gender;
  onPrevStep: () => void;
  onNextStep: () => void;
}

export default function DetailInput({
  gender,
  onPrevStep,
  onNextStep,
}: DetailInputProps) {
  const {
    profileImage,
    commonInput,
    setCommonInput,
    showPersona,
    setShowPersona,
    handleDeleteImageClick,
    handleImageChange,
    textRef,
    handleUserNameClick,
    handleDirectionClick,
    GenerateButtonDisabled,
    uploadType,
    isPending,
    handleApplyClick,
    handleHeaderCloseClick,
    handleProcessCancelClick,
  } = useDetailInput({ onNextStep, gender });

  if (!uploadType) {
    onPrevStep();
  }

  return (
    <>
      {isPending && (
        <GenerateLoading handleCancelClick={handleProcessCancelClick} />
      )}

      <Header.Root>
        <Header.Section>
          <Header.PrevButton onPrevClick={onPrevStep} />
          <Header.Title>Set Profile</Header.Title>
        </Header.Section>
        <Header.Section>
          <SubCloseButton onCloseClick={handleHeaderCloseClick} />
        </Header.Section>
      </Header.Root>

      <SetProfileView
        handleImageChange={handleImageChange}
        profileImage={profileImage}
        commonInput={commonInput}
        showPersona={showPersona}
        setShowPersona={setShowPersona}
        handleDeleteImageClick={handleDeleteImageClick}
        setCommonInput={setCommonInput}
        handleUserNameClick={handleUserNameClick}
        handleDirectionClick={handleDirectionClick}
        textRef={textRef}
        handleApplyClick={handleApplyClick}
        isPending={isPending}
        GenerateButtonDisabled={GenerateButtonDisabled}
      />
    </>
  );
}
